module.exports = __webpack_public_path__ + "img/start.338f2e04.svg";